import {IComponentOptions, ILogService} from "angular";
import {StateService} from "@uirouter/angularjs";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {Application} from "../../../model/Application";
import {LoadingService} from "../../../loading/loading.service";
import {ApplicationService} from "../../application.service";

class ApplicationReopenSummaryModalController {

    public modalInstance: IModalInstanceService;
    public resolve: any;
    public close: any;
    public dismiss: any;

    public application: Application;
    public outcomeComment: string;

    /* @ngInject */
    constructor(private $log: ILogService,
                private $state: StateService,
                private toaster: any,
                private loadingService: LoadingService,
                private applicationService: ApplicationService) {
    }

    public $onInit() {
        this.application = this.resolve.application;
        this.outcomeComment = this.application.outcomeComment;
    }

    public submit() {
        this.$log.info("submit()");
        this.loadingService.show();

        if (this.outcomeComment !== this.application.outcomeComment) {
            this.application.outcomeComment = this.outcomeComment;
        }

        this.applicationService.reopenStudentCreditApplicationSummary(this.application)
            .then((application) => {
                this.$log.debug("reopen summary:", application);

                this.application = application;

                this.toaster.pop({type: "success", title: "Summary reopened"});
                this.close({$value: application});
                this.$state.go("dashboard", {}, {reload: true});

            })
            .finally(() => {
                    this.loadingService.hide();
                }
            );
    }

    public cancel() {
        this.dismiss({$value: "cancel"});
    }

}

export const ApplicationReopenSummaryModalComponent: IComponentOptions = {
    bindings: {
        modalInstance: "<",
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: ApplicationReopenSummaryModalController,
    template: require("./application-reopen-summary-modal.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/application/modals/reopen-summary-modal/application-reopen-summary-modal.component.ts